import { render, staticRenderFns } from "./SeparadorAtendimentoResolvido.vue?vue&type=template&id=9e3c87bc&scoped=true"
import script from "./SeparadorAtendimentoResolvido.vue?vue&type=script&lang=js"
export * from "./SeparadorAtendimentoResolvido.vue?vue&type=script&lang=js"
import style0 from "./SeparadorAtendimentoResolvido.vue?vue&type=style&index=0&id=9e3c87bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3c87bc",
  null
  
)

export default component.exports